export default "mdc-list {\n  padding: 0;\n}\n\np {\n  margin: 0;\n  padding: 16px;\n}"